import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const PostDetail = () => {
  const { postid } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/posts/${postid}`)
      .then(res => res.json())
      .then(data => setPost(data))
      .catch(err => console.error("Post fetch error:", err));
  }, [postid]);

  if (!post) return <p>Loading...</p>;

  return (
    <div>
      <h2>{post.title || "Post"}</h2>
      <p>{post.caption}</p>
      {/* Render more post content here */}
    </div>
  );
};

export default PostDetail;
